/*
 * Lumeer: Modern Data Definition and Processing Platform
 *
 * Copyright (C) since 2017 Lumeer.io, s.r.o. and/or its affiliates.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export const greyscale: string[] = [
  '#000000',
  '#263238',
  '#37474f',
  '#455a64',
  '#546e7a',
  '#607d8b',
  '#78909c',
  '#90a4ae',
  '#b0bec5',
  '#cfd8dc',
  '#eceff1',
];
export const sepia: string[] = [
  '#101010',
  '#212121',
  '#424242',
  '#616161',
  '#757575',
  '#9e9e9e',
  '#bdbdbd',
  '#e0e0e0',
  '#eeeeee',
  '#f5f5f5',
  '#fafafa',
  '#00b388',
];

export const saturated: string[] = [
  '#f44336', // red
  '#e91e63', // pink
  '#9c27b0', // purple
  '#673ab7', // deep-purple
  '#3f51b5', // indigo
  '#2196f3', // blue
  '#03a9f4', // light-blue
  '#009688', // teal
  '#4caf50', // green
  '#8bc34a', // light-green
  '#ffeb3b', // yellow
  '#ff5722', // deep-orange
];

export const palette: string[] = [
  // 100
  '#ffcdd2', // red
  '#f8bbd0', // pink
  '#e1bee7', // purple
  '#d1c4e9', // deep-purple
  '#c5cae9', // indigo
  '#bbdefb', // blue
  '#b3e5fc', // light-blue
  '#b2dfdb', // teal
  '#c8e6c9', // green
  '#dcedc8', // light-green
  '#fff9c4', // yellow
  '#ffccbc', // deep-orange

  // 200
  '#ef9a9a', // red
  '#f48fb1', // pink
  '#ce93d8', // purple
  '#b39ddb', // deep-purple
  '#9fa8da', // indigo
  '#90caf9', // blue
  '#81d4fa', // light-blue
  '#80cbc4', // teal
  '#a5d6a7', // green
  '#c5e1a5', // light-green
  '#fff59d', // yellow
  '#ffab91', // deep-orange

  // 300
  '#e57373', // red
  '#f06292', // pink
  '#ba68c8', // purple
  '#9575cd', // deep-purple
  '#7986cb', // indigo
  '#64b5f6', // blue
  '#4fc3f7', // light-blue
  '#4db6ac', // teal
  '#81c784', // green
  '#aed581', // light-green
  '#fff176', // yellow
  '#ff8a65', // deep-orange

  // 400
  '#ef5350', // red
  '#ec407a', // pink
  '#ab47bc', // purple
  '#7e57c2', // deep-purple
  '#5c6bc0', // indigo
  '#42a5f5', // blue
  '#29b6f6', // light-blue
  '#26a69a', // teal
  '#66bb6a', // green
  '#9ccc65', // light-green
  '#ffee58', // yellow
  '#ff7043', // deep-orange

  // 600
  '#e53935', // red
  '#d81b60', // pink
  '#8e24aa', // purple
  '#5e35b1', // deep-purple
  '#3949ab', // indigo
  '#1e88e5', // blue
  '#039be5', // light-blue
  '#00897b', // teal
  '#43a047', // green
  '#7cb342', // light-green
  '#fdd835', // yellow
  '#f4511e', // deep-orange

  // 700
  '#d32f2f', // red
  '#c2185b', // pink
  '#7b1fa2', // purple
  '#512da8', // deep-purple
  '#303f9f', // indigo
  '#1976d2', // blue
  '#0288d1', // light-blue
  '#00796b', // teal
  '#388e3c', // green
  '#689f38', // light-green
  '#fbc02d', // yellow
  '#e64a19', // deep-orange

  // 800
  '#c62828', // red
  '#ad1457', // pink
  '#6a1b9a', // purple
  '#4527a0', // deep-purple
  '#283593', // indigo
  '#1565c0', // blue
  '#0277bd', // light-blue
  '#00695c', // teal
  '#2e7d32', // green
  '#558b2f', // light-green
  '#f9a825', // yellow
  '#d84315', // deep-orange

  // 900
  '#b71c1c', // red
  '#880e4f', // pink
  '#4a148c', // purple
  '#311b92', // deep-purple
  '#1a237e', // indigo
  '#0d47a1', // blue
  '#01579b', // light-blue
  '#004d40', // teal
  '#1b5e20', // green
  '#33691e', // light-green
  '#f57f17', // yellow
  '#bf360c', // deep-orange
];

const paletteOrder = [11, 10, 8, 6, 2, 4, 0, 7, 1, 5, 3, 9];
//24, 48, 72

export const selectDefaultPalette = [
  ...paletteOrder.map(i => palette[i]),
  ...paletteOrder.map(i => palette[i + 24]),
  ...paletteOrder.map(i => palette[i + 48]),
  ...paletteOrder.map(i => palette[i + 72]),
];
